// Translate the server's structured failure reasons (which carry stable
// codes like STALE_QUANTITY, DD_REJECTED, etc.) into plain English. Used
// by both the My Requests detail panel and the action layer's toasts so
// a DD-attempt failure surfaces consistently wherever the user sees it.
//
// Not meant to be exhaustive. Codes absent from this map fall through to
// the default below, which strips the CODE: prefix and shows the server's
// own text - that is the intended path for codes whose server message is
// already written for a user (SUBSCRIPTION_NOT_FOUND, for one). Add a case
// here only when the server's wording needs replacing, not merely covering.

export const friendlyFailureMessage = (reason) => {
  if (!reason) return null
  const upper = reason.toUpperCase()
  if (upper.startsWith('STALE_QUANTITY')) {
    return 'The seat count has changed at Dicker Data since this was submitted. Cancel this request and create a new one with the current numbers.'
  }
  if (upper.startsWith('OVER_THRESHOLD')) {
    return "The change exceeds your role's auto-approval threshold. Resubmit through the approval queue or reduce the change."
  }
  if (upper.startsWith('SUB_REMOVED_AT_DD')) {
    return 'One or more subscriptions have been removed at Dicker Data since you opened your cart.'
  }
  if (upper.startsWith('LIVE_READ_FAILED')) {
    return 'Could not reach Dicker Data to verify current quantities. Try again in a few minutes.'
  }
  if (upper.startsWith('PRODUCT_EXCLUDED')) {
    return 'One or more products in this basket need Sales Admin assistance and cannot be modified here. Raise a ticket on the Sales Admin queue.'
  }
  if (upper.startsWith('DD_REJECTED')) {
    // The DD_REJECTED template wraps DD's own message in parentheses;
    // pull that out so users see the vendor's explanation, not our
    // wrapper boilerplate.
    const match = reason.match(/\(([^)]+)\)\.?\s*$/)
    if (match) return `Dicker Data rejected the change: ${match[1]}`
    return reason.replace(/^DD_REJECTED:\s*/i, 'Dicker Data rejected the change: ')
  }
  // Unknown shape: strip a leading CODE: prefix if present, otherwise
  // pass through.
  return reason.replace(/^[A-Z_]+:\s*/, '')
}
